import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import Flex from 'components/UI/Flex/Flex'
import CalendarWrapper from 'components/Modules/Slots/AdvancedTeachersHistory/components/CalendarWrapper/CalendarWrapper'
import slotsAdvancedTeachersHistoryStore, {
  ActionType,
} from 'Stores/slotsAdvancedTeachersHistoryStore'
import CompanyLocationSelects from '../components/CompanyLocationSelects/CompanyLocationSelects'
import SlotColorTypes from 'components/Modules/Slots/components/SlotColorTypes/SlotColorTypes'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import CustomerList from 'components/Modules/Slots/AdvancedTeachersHistory/components/CustomerList/CustomerList'
import styles from '../BookedSchedule/BookedSchedule.module.scss'
import { superAxiosRequest } from 'axiosApi'

const AdvancedTeachersHistory = () => {
  const {
    companiesList,
    locations,
    selectedLocation,
    selectedCompany,
    setData,
    resetData,
    selectedDates,
    selectedDate,
  } = slotsAdvancedTeachersHistoryStore

  const [slotTypesLocal, setSlotTypesLocal] = useState(null)
  const [customersLocal, setCustomersLocal] = useState(null)
  const [isCustomersLoadingLocal, setisCustomersLoadingLocal] = useState(false)

  const setCustomersAndSlots = async () => {
    if (selectedDate) {
      try {
        setisCustomersLoadingLocal(true)
        const { data } = await superAxiosRequest({
          method: 'get',
          link: 'online_schedule/admin/advanced-history',
          params: {
            date: selectedDate,
            location: selectedLocation.id,
            time: new Date().getTime(),
          },
        })

        setCustomersLocal(data.booked_slots)
        setSlotTypesLocal(data.slot_types)
        setisCustomersLoadingLocal(false)
      } catch (error) {
        setisCustomersLoadingLocal(false)
      }
    }
  }

  useEffect(() => resetData(ActionType.resetCalendar), []) // eslint-disable-line

  useEffect(() => {
    setCustomersAndSlots()
  }, [selectedDate]) // eslint-disable-line

  return (
    <>
      <ContentHeader title='Расписание преподавателей' />
      <Flex withGap classes={styles.wrapper}>
        <div className={styles.selectors_wrapper}>
          <CompanyLocationSelects
            companiesList={companiesList}
            locationsList={locations}
            selectedLocation={selectedLocation}
            selectedCompany={selectedCompany}
            onResetData={resetData}
            onSetData={setData}
          />
        </div>
        {selectedLocation && selectedCompany && (
          <CalendarWrapper classes={styles.calendar_wrapper} />
        )}
        {selectedDates.size > 0 && (
          <>
            {isCustomersLoadingLocal ? (
              <div className={styles.loader}>
                <Loader />
              </div>
            ) : (
              <>
                {customersLocal?.length > 0 ? (
                  <>
                    <CustomerList
                      list={customersLocal}
                      types={slotTypesLocal || []}
                    />
                    <div className={styles.selectors_wrapper}>
                      <SlotColorTypes
                        types={slotTypesLocal || []}
                        withIcon={true}
                      />
                    </div>
                  </>
                ) : (
                  <h1 className={styles.calendar_wrapper}>
                    Забронированных слотов сотрудниками на выбранную дату нет
                  </h1>
                )}
              </>
            )}
          </>
        )}
      </Flex>
    </>
  )
}

export default observer(AdvancedTeachersHistory)
